import { getCurrentProductCode, type ProductCode } from '@common/api/productContext';

import { isMarketIntelligenceAdminAvailableFor } from './marketIntelligenceAvailabilityCore';

export const isMarketIntelligenceMvpEnabled = (): boolean => import.meta.env.VITE_MARKET_INTELLIGENCE_MVP === 'true';

export const isMarketIntelligenceAdminAvailable = (
    productCode: ProductCode = getCurrentProductCode(),
    mvpEnabled = isMarketIntelligenceMvpEnabled(),
): boolean => isMarketIntelligenceAdminAvailableFor(productCode, mvpEnabled);

export { isMarketIntelligenceAdminAvailableFor };
